<template lang="jade">
.row
  .col-xs-12
    fieldset
      legend dxSendIRCommand
      span signal
      input(type='text' v-model='command')
      button(@click="dxSendIRCommand") dxSendIRCommand
  .row
    .col-xs-12
      fieldset
        legend dxSendIRSignal
        span signal
        input(type='text' v-model='hexValue')
        button(@click="dxSendIRSignal()") dxSendIRSignal
  .row
    .col-xs-offset-4.col-xs-6
      button.btn.btn-info(@click="up") Up
    .col-xs-offset-2.col-xs-1
      button.btn.btn-info(@click="left") Left
    .col-xs-offset-1.col-xs-2
      button.btn.btn-primary(@click="select") Select
    .col-xs-4
      button.btn.btn-primary.btn-info(@click="right") Right
    .col-xs-offset-4.col-xs-6
      button.btn.btn-info(@click="down") Down
    .col-xs-offset-2.col-xs-4
      button.btn(@click="menu") Menu
    .col-xs-6
      button.btn.btn-primary(@click="play") Play
</template>

<style scoped>
  .thin {
    width: 16%;
  }
</style>
<script>
  export default {
    data: () => {
      return {
        command: '',
        hexValue: ''
      }
    },
    methods: {
      up () {
        this.dxSendIRSignal('77e150fb')
      },
      down () {
        this.dxSendIRSignal('77e130fb')
      },
      left () {
        this.dxSendIRSignal('77e190fb')
      },
      right () {
        this.dxSendIRSignal('77e160fb')
      },
      menu () {
        this.dxSendIRSignal('77e1c0fb')
      },
      select () {
        this.dxSendIRSignal('77e13afb')
      },
      play () {
        this.dxSendIRSignal('77e1fafb')
      },
      sendAPI (cmd, params) {
        this.$dispatch('sendAPI', cmd, params)
      },
      dxSendIRCommand () {
        this.sendAPI('dxSendIRCommand', {
          command: this.command
        })
      },
      dxSendIRSignal (cmd) {
        console.log(this.hexValue)
        this.sendAPI('dxSendIRSignal', {
          signal: cmd || this.hexValue
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ir.vue?6b7a32b2